import axios from "./axios"
import { userData } from "./Currentuserdata"


export default {
    /**
     * Get All Customers
     * @api {Get} managecustomer
     * @param {object} params
     */
    getProductsToBill(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/provider',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },


    /**
     * Get All Products
     * @api {Get} manageproduct/provider
     */
    getProducts(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    getProductsHistory(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/history',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    getProductByID(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/findProductById',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },
    getProductsByArrayID(array) {
        const options = {
            method: 'POST',
            url: 'manageproduct/products/findProductsByArrayID',
            headers: { 'content-type': 'application/json' },
            data: array
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    filterProducts(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    filterProductSpecialInventory(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/filtered/specialinventory',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },
    
    filterProductSpecialInventoryWithWareHouseAndProviders(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/filtered/specialinventoryWithWareHouseAndProviders',
            headers: { 'content-type': 'application/json' },
            params: params
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    filterProductsColumn(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/filteredcolumn',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    // Functions to import products from spreadsheet
    getInitialID(value) {
        const options = {
            method: 'GET',
            url: 'manageproduct/initialID',
            headers: { 'content-type': 'application/json' },
            params: { value }
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },
    importProducts(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/products/import',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },
    /**
     * Importación de productos V2
     * Rechaza con el cuerpo del backend ({ message, errors: [{ path, message }] }) para marcar celdas.
     * noAutomaticRetry: el interceptor no reintenta por "Network Error" (evita importar dos veces).
     */
    importProductsV2(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/products/v2/import',
            headers: { 'content-type': 'application/json' },
            data: data,
            noAutomaticRetry: true
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response?.data || { message: error.message, errors: [] })
                })
        });
    },


    /**
     * Add Product
     * @api {POST} manageproduct
     */
    addProduct(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct',
            headers: { 'content-type': 'multipart/form-data' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
    * get Products of provider
    * @api {POST} manageproduct
    */
    getProductsProvider(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/providerproducts',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsProviderHistory(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/providerproducts/list/history',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsProviderFiltered(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/providerproducts/list/filtered',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsWarehouse(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/warehouseproducts',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsWarehouseHistory(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/warehouseproducts/list/history',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsWarehouseFiltered(data) {
        const options = {

            method: 'POST',
            url: 'manageproduct/warehouseproducts/list/filtered',
            headers: { 'content-type': 'application/json' },
            data: data
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /**
     * Update Product
     * @api {PUT} manageproduct
     */
    updateProduct(id, data) {

        const options = {
            method: 'PUT',
            url: `manageproduct/${id}`,
            headers: { 'content-type': 'multipart/form-data' },
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    /**
     * Delete provider
     * @api {DELETE} manageprovider/:id
     */
    deleteProduct(id) {
        const options = {
            method: 'DELETE',
            url: `manageproduct/${id}`,
            headers: { 'content-type': 'application/json' },
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    logicalDeleteProduct(id) {
        const options = {
            method: "PUT",
            url: `manageproduct/logicaldelete/${id}`,
            headers: { "content-type": "application/json" },
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.message)
                });
        });
      },

    /**
     * Get products price list
     */
    priceList() {
        const user = userData()
        const options = {
            method: 'GET',
            url: 'manageproduct/pricelistnoparam',
            headers: { 'content-type': 'application/json' },
            data: {
                ID_Branch: user.branch,
                ID_Business: user.businessid,
            }
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getProductPriceListMargins(id) {
        const options = {
            method: 'GET',
            url: `manageproduct/products/${id}/pricelist-margins`,
            headers: { 'content-type': 'application/json' }
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    updateProductPriceListMargins(id, data) {
        const options = {
            method: 'PUT',
            url: `manageproduct/products/${id}/pricelist-margins`,
            headers: { 'content-type': 'application/json' },
            data,
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /**
     * Get history product
     * @api {Get} manageinventory
     */
    getHistoryProduct(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getAllBatch(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getAllBatch',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /**
     * Get IN's history product
     * @api {Get} manageinventory/getIns
     */
    getINsHistoryProduct(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getIns',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getINsHistoryProductHistory(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getIns/list/history',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getINsHistoryProductFiltered(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getIns/list/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /**
     * Get IN's history product
     * @api {Get} manageinventory/getInventory
     */
    getProductInventory(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getInventory',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductInventoryHistory(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getInventory/list/history',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getProductInventoryHistoryByColumns(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getInventory/list/historybycolumns',
            headers: { 'content-type': 'application/json' },
            params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getInventorySearchForTransfer(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getInventory/search/transfer',
            headers: { 'content-type': 'application/json' },
            params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductInventoryFiltered(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getInventory/list/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /** API'S FOR PURCHASE ORDERS **/


    /**
     * Get All Products to Bill For Purchase Orders
     * @api {Get} manageproducts
     * @param {object} params
     */
    getProductsToBillForPurchaseOrders(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/purchaseorders/products',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsToBillForPurchaseOrdersHistory(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/purchaseorders/products/list/history',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getProductsToBillForPurchaseOrdersFiltered(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/purchaseorders/products/list/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**.
     * Payload:
     * {
     *   business, branch, provider, noProvider,
     *   codes: ["ID-001", "ALT-123", ...]
     * }
     */
    getProductsToBillForPurchaseOrdersByCodes(params) {
        const options = {
            method: 'POST',
            url: 'manageproduct/purchaseorders/products/list/bycodes',
            headers: { 'content-type': 'application/json' },
            data: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    /**
     * Get All Products to Bill For Invoice
     * @api {Get} manageproducts
     * @param {object} params
     */
    getProductsToBillForInvoice(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/invoice/products', 
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    /**
     * Get All Products to Bill For Invoice
     * @api {Get} manageproducts
     * @param {object} params
     */
    getProductsToBillForInvoiceFiltered(params) {
        const enablenegativeitem = JSON.parse(localStorage.getItem("user")).enablenegativeitem ?? 0;
        const options = {
            method: 'GET',
            url: 'manageproduct/invoice/products/filtered',
            headers: { 'content-type': 'application/json' },
            params: {...params, enablenegativeitem}
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getAllWithServicesFiltered(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/invoice/productsandservices/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getAllWithServicesFilteredPaginated(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/invoice/productsandservices/filtered/paginated',
            headers: { 'content-type': 'application/json' },
            params: {
                ...params,
                page: params.page || 1,
                limit: params.limit || 20,
            }
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    getKardex(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getKardex',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {

                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })

    },

    getKardexHistory(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getKardex/list/history',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {

                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })

    },

    getKardexFiltered(params) {
        const options = {
            method: 'GET',
            url: 'manageinventory/getKardex/list/filtered',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {

                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })

    },

    getTotalProductsByLot(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/invoice/getTotalProductsByLot',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    async getInvoiceProductsQuantity( body ) {
        const options = {
            method: 'POST',
            url: 'manageproduct/invoice/getInvoiceProductsQuantity',
            headers: { 'content-type': 'application/json' },
            data: body
        }

        const result = await axios( options );

        return result.data;
    },

    newGetProducts(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/newGetProducts',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getItemsStructureByProduct(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/getItemsStructureByProduct',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    saveStructureOfProduct(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/saveStructureOfProduct',
            headers: { 'content-type': 'application/json' },
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },

    importCheckFile(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/imports/importCheckFile',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                    })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },

    /**
     * Get Products for Template with Cost Information
     * @api {GET} manageproduct/template/products
     * @param {object} params - Parámetros de consulta incluyendo ID_Business
     */
    getProductsForTemplate(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/template/products',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    /**
     * Check Products Existence
     * @api {POST} manageproduct/check-existence
     * @param {object} data - Objeto con array de IDs de productos a verificar
     * @returns {array} Array con los IDs que NO existen en el sistema
     */
    checkProductsExistence(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/check-existence',
            headers: { 'content-type': 'application/json' },
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    importDataOfFile(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/imports/importDataOfFile',
            headers: { 'content-type': 'application/json' },
            data: data
        };
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },

    /**
     * Importar existencias de productos masivamente
     * @api {POST} manageproduct/products/import-stock
     * @param {object} data - Objeto con array de productos y sus existencias por bodega
     * @returns {object} Resultado de la importación con resumen y detalles
     */
    importarExistenciaProducto(data) {
        const options = {
            method: 'POST',
            url: 'manageproduct/products/import-stock',
            headers: { 'content-type': 'application/json' },
            data: data,
            timeout: 80000 // 80 segundos de timeout para importación por lotes
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },

    /**
     * Get Products for Bulk Edit
     * @api {Get} manageproduct/products/bulk-edit
     * @param {object} params
     */
    getProductsForBulkEdit(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/bulk-edit',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },

    /**
     * Update Products Bulk
     * @api {Put} manageproduct/products/bulk-update
     * @param {object} data
     */
    updateProductsBulk(data) {
        const options = {
            method: 'PUT',
            url: 'manageproduct/products/bulk-update',
            headers: { 'content-type': 'application/json' },
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },
    getProductsForProfitPercentageEdition(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/profit-percentage',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },
    getPriceListProductsForEdition(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/pricelist/products/edition',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.response?.data?.message || error.message)
                })
        });
    },
    updatePriceListProductsPricesBulk(data) {
        const options = {
            method: 'PUT',
            url: 'manageproduct/pricelist/products/prices',
            headers: { 'content-type': 'application/json' },
            data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.response?.data?.message || error.message)
                })
        });
    },
    updateProductsProfitPercentageBulk(data) {
        const options = {
            method: 'PUT',
            url: 'manageproduct/products/profit-percentage',
            headers: { 'content-type': 'application/json' },
            data: data
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        });
    },
    getItemCostByIdProduct(params) {
        const options = {
            method: 'GET',
            url: 'manageproduct/products/getItemCostByIdProduct',
            headers: { 'content-type': 'application/json' },
            params: params
        }
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    console.log(error)
                    reject(error.message)
                })
        })
    },
}
